import React from "react";
import { Link } from "react-router-dom";
import "./integration.css";

function TelegramIntegration() {
  return (
    <div className="integration-container">
      <div className="integration-header">
        <h2>Telegram Integration</h2>
        <Link to="/dashboard" className="back-link">← Back to Dashboard</Link>
      </div>

      <div className="integration-content">
        <p>Get instant alerts from your smart contracts sent to your Telegram chat.</p>

        <h3>Setup Instructions</h3>
        <ol>
          <li>Open Telegram and create a new bot using <strong>@BotFather</strong>.</li>
          <li>Save the bot token provided by BotFather.</li>
          <li>Add the bot to your desired chat or channel.</li>
          <li>Paste the bot token into your integration settings.</li>
          <li>Save and start receiving notifications!</li>
        </ol>

        <div className="integration-actions">
          <button className="copy-btn" onClick={() => navigator.clipboard.writeText("YOUR_TELEGRAM_BOT_TOKEN")}>
            Copy Bot Token
          </button>
          <a href="https://t.me/BotFather" target="_blank" rel="noopener noreferrer" className="btn external-btn">
            Open BotFather
          </a>
        </div>
      </div>
    </div>
  );
}

export default TelegramIntegration;
